import { useTranslation } from 'react-i18next';
import { CategoryDropdown } from './components/CategoryDropdown';
import { useGetGamesList } from 'src/hooks/useGetGamesList';
import { jackpotGamesList, liveGamesList } from 'src/constants/gameCategories';

export const GameCategories = () => {
  const { t } = useTranslation();
  const gamesList = useGetGamesList();

  return (
    <div className="w-full flex flex-col justify-center items-center">
      <p className="text-left text-base text-sgc_title font-bold w-full px-2 mb-2">
        {t('sidebarGameCategories.title')}
      </p>
      <CategoryDropdown title="sidebarGameCategories.games" options={gamesList} />
      <CategoryDropdown title="sidebarGameCategories.live" options={liveGamesList} />
      <CategoryDropdown title="sidebarGameCategories.jackpotGames" options={jackpotGamesList} />
    </div>
  );
};
